import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { SCREENS } from "../../../../routes/screens";
// @ts-expect-error Logo Image
import logo from "../../../assets/header-logo.svg";
// @ts-expect-error Logo White Image
import whiteLogo from "../../../assets/header-white.svg";
import { SIDE_PANEL_ANCHOR, SidePanel } from "../../SidePanel/SidePanel";
import { NavProfileButton } from "../NavProfileButton/NavProfileButton";
import { NavProfileContent } from "../NavProfileContent/NavProfileContent";
import "./NavProfileSidePanel.css";
import { NavLoginContainer } from "../NavLoginContainer/NavLoginContainer";
import { Box, Theme } from "@mui/material";
import { useAppSelector } from "../../../../store/hooks";
import { useSetAtom } from "jotai";
import { hamburgerMenuHeightAtom } from "../../../../atoms/navAtoms";
import { Size } from "../../SessionScheduleGuide/SessionScheduleGuide";
import { useResizeObserver } from "usehooks-ts";

export interface NavProfileSidePanelProps {
  darkMode: boolean | string | null;
  additionalSxProps?: (theme: Theme) => object;
}

export const NavProfileSidePanel = ({
  darkMode,
  additionalSxProps,
}: NavProfileSidePanelProps) => {
  const { user } = useAppSelector((state) => state.accountInfo);
  const [showSidePanel, setShowSidePanel] = useState(false);
  const setHeight = useSetAtom(hamburgerMenuHeightAtom);
  const hamburgerButtonRef = useRef<HTMLButtonElement>(null);
  const onResize = useCallback(
    (size: Size) => {
      setTimeout(() => {
        setHeight(size.height || 0);
      }, 0);
    },
    [setHeight],
  );
  useResizeObserver({
    ref: hamburgerButtonRef,
    box: "border-box",
    onResize,
  });

  const handleClose = () => setShowSidePanel(false);
  return (
    <Box
      sx={(theme) => ({
        position: "absolute",
        left: `${HAMBURGER_MENU_MARGIN}px`,
        ...(additionalSxProps ? additionalSxProps(theme) : {}),
      })}
    >
      <button
        className="nav-profile-button-mobile"
        onClick={() => {
          setShowSidePanel((currentValue) => !currentValue);
        }}
        ref={hamburgerButtonRef}
      >
        <FontAwesomeIcon
          icon={faBars}
          color="var(--text-primary-color)"
          size="lg"
        />
      </button>
      <SidePanel
        anchor={SIDE_PANEL_ANCHOR.LEFT}
        isOpen={showSidePanel}
        onClose={handleClose}
      >
        <div className="nav-profile-side-bar-container">
          <div>
            {user ? (
              <NavProfileButton
                onClick={handleClose}
                isMobile={true}
                expanded
              />
            ) : (
              <Link to={SCREENS.SIGNED_OUT_HOME_SCREEN} onClick={handleClose}>
                <img
                  className="nav-profile-side-panel-logo"
                  alt="engineears"
                  src={darkMode ? whiteLogo : logo}
                />
              </Link>
            )}
            <NavProfileContent user={user} onClose={handleClose} />
          </div>
          {!user && <NavLoginContainer column onClick={handleClose} />}
        </div>
      </SidePanel>
    </Box>
  );
};

export const HAMBURGER_MENU_MARGIN = 25;
